import { createContext, useContext } from 'react';

export type AppColorSchemeValue = {
  colorScheme: 'light' | 'dark';
  isLightMode: boolean;
  isDarkMode: boolean;
};

export const appColorSchemeContext = createContext<AppColorSchemeValue | null>(null);

export function useAppColorScheme(): AppColorSchemeValue {
  const context = useContext(appColorSchemeContext);
  if (!context) {
    throw new Error('useAppColorScheme must be used within AppColorSchemeProvider');
  }

  return context;
}
